import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMsg: (error && (error.message || String(error))) || "" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, errorMsg: "" });
  };

  handleHome = () => {
    this.setState({ hasError: false, errorMsg: "" });
    window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-[70vh] flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md w-full bg-white rounded-3xl border border-[#0D1B2A]/8 p-8 text-center shadow-lg">
          <div className="w-16 h-16 mx-auto rounded-full bg-[#F7F2E7] flex items-center justify-center">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <div className="eyebrow mt-4">Algo saiu do lugar</div>
          <h1 className="font-display text-3xl text-[#0D1B2A] mt-2">Momento inesperado</h1>
          <p className="mt-3 text-sm text-[#6B7280]">
            Tivemos um pequeno tropeço ao carregar a página. Tente novamente, e se persistir, chame a Karine no WhatsApp para te ajudarmos rapidinho.
          </p>
          {this.state.errorMsg && (
            <p className="mt-3 text-[11px] text-[#6B7280] font-mono break-words px-2">
              {this.state.errorMsg.slice(0, 220)}
            </p>
          )}
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <button data-testid="error-retry" onClick={this.handleReset} className="btn-gold">
              Tentar novamente
            </button>
            <button data-testid="error-home" onClick={this.handleHome} className="btn-outline-navy">
              Voltar ao início
            </button>
          </div>
          <a href="https://wa.me/5542984285953" target="_blank" rel="noreferrer" className="mt-4 inline-block text-xs text-[#D4AF37]">
            Falar no WhatsApp
          </a>
        </div>
      </div>
    );
  }
}
